// extracted by mini-css-extract-plugin
export default {"formHeading":"SponsorForm_formHeading__F2qc9","formControl":"SponsorForm_formControl__DfOG-","btnDiv":"SponsorForm_btnDiv__Y52rQ","primaryBtn":"SponsorForm_primaryBtn__vFva3"};